import promocode from '~/assets/icons/promocode.svg';
import question from '~/assets/icons/question.svg';
// import surpriseBox from '~/assets/icons/surprise_box.svg';

export enum QuestMenu {
	Quests = 'quests',
	// Daily = 'daily',
	Promo = 'cases',
}

export const questMenuNames: Record<QuestMenu, string> = {
	[QuestMenu.Quests]: 'Ежедневные задачи',
	// [QuestMenu.Daily]: 'Ежедневные награды',
	[QuestMenu.Promo]: 'Промокоды',
};

export const questMenuIcons: Record<QuestMenu, string> = {
	[QuestMenu.Quests]: question,
	// [QuestMenu.Daily]: surpriseBox,
	[QuestMenu.Promo]: promocode,
};
